import { Input } from '@arco-design/mobile-react';
import { IconSearch } from '../components/icons';
import MobileSelect from '../components/MobileSelect';
import MobileTag from '../components/MobileTag';
import type { PortalDraftListItem } from '../../modules/drafts/model/drafts';

type Props = {
  drafts: PortalDraftListItem[];
  keyword: string;
  onKeywordChange: (value: string) => void;
  onOpenDraft: (id: string) => void;
  total: number;
  loading: boolean;
  error?: string;
  hasMore: boolean;
  onRetry: () => void;
  onLoadMore: () => void;
};

function draftDate(value: string) {
  const date = value.match(/^\d{4}-\d{2}-\d{2}/);
  return date?.[0] ?? value;
}

function MobileDraftsView(props: Props) {
  const visibleDrafts = props.drafts;

  return <div className="mobile-page mobile-tasks mobile-drafts">
    <div className="mobile-task-filter-panel">
      <div className="mobile-task-search">
        <Input className="mobile-control-input" border="none" prefix={<IconSearch />} clearable value={props.keyword} placeholder="搜索草稿名称或内容" onInput={(_, value) => props.onKeywordChange(value)} />
      </div>
      <div className="mobile-task-flow-filter">
        <MobileSelect value="all" onChange={() => undefined} ariaLabel="按项目流程筛选" placement="top" disabled
          options={[{ label: '全部项目流程', value: 'all' }]} />
        <span className="mobile-task-tools__count">{props.total} 项</span>
      </div>
    </div>
    <div className="mobile-task-list" role="list" aria-busy={props.loading}>
      {props.error ? <div className="mobile-empty" role="alert"><strong>草稿加载失败</strong><span>{props.error}</span><button type="button" onClick={props.onRetry}>重新加载</button></div> : null}
      {visibleDrafts.map((draft) => <article className="mobile-task-card mobile-draft-card" role="listitem" key={draft.draftPublicId}>
        <button className="mobile-draft-card__open" type="button" aria-label={`恢复草稿：${draft.title}`} onClick={() => props.onOpenDraft(draft.draftPublicId)}>
        <div className="mobile-task-card__head">
          <strong>{draft.title}</strong>
          <MobileTag>草稿</MobileTag>
        </div>
        <span className="mobile-task-card__fields">
          {draft.summaryItems.slice(0, 4).map((field) => <span className="mobile-task-card__field" key={`${draft.draftPublicId}-${field.label}`}>
            <span>{field.label}：</span><span>{field.value}</span>
          </span>)}
        </span>
        <span className="mobile-task-card__footer"><small>更新于 {draftDate(draft.lastSavedAt)}</small></span>
        </button>
      </article>)}
      {!props.loading && !props.error && visibleDrafts.length === 0 ? <div className="mobile-empty"><strong>暂无草稿</strong><span>当前没有符合条件的草稿。</span></div> : null}
      {props.loading ? <div className="mobile-empty" role="status">正在加载草稿</div> : !props.error && props.hasMore ? <button className="mobile-task-load-more" type="button" onClick={props.onLoadMore}>加载更多草稿</button> : visibleDrafts.length && !props.error ? <div className="mobile-empty">暂无更多数据</div> : null}
    </div>
  </div>;
}

export default MobileDraftsView;
